/*
 * Module for the Mailing Labels report criteria page
 */
rs.module("content/reports/criteria/mailinglabelscriteria",

    ["common/select-helper", "common/visibility"],

    function (selectHelper, visibility) {

        // Initialize the page
        function initialize(jsSelectors, backendUrls, modes, participantTypes) {

            var criteria = $.js(jsSelectors.criteria);

            var modeSelect = criteria.js(jsSelectors.modeSelect);
            var individualModeContainer = criteria.js(jsSelectors.individualModeContainer);
            var groupModeContainer = criteria.js(jsSelectors.groupModeContainer);
            var useDefaultAddressTypeCheckBox = criteria.js(jsSelectors.useDefaultAddressTypeCheckBox);
            var addressTypeSelect = criteria.js(jsSelectors.addressTypeSelect);
            var participantTypeSelect = criteria.js(jsSelectors.participantTypeSelect);
            var participantRecipientContainer = criteria.js(jsSelectors.participantRecipientContainer);
            var participantDroContainer = criteria.js(jsSelectors.participantDroContainer);
            var participantMemberContainer = criteria.js(jsSelectors.participantMemberContainer);
            var benefitStatusSelect = criteria.js(jsSelectors.benefitStatusSelect);
            var benefitTypeSelect = criteria.js(jsSelectors.benefitTypeSelect);
            var insuranceCarrierSelect = criteria.js(jsSelectors.insuranceCarrierSelect);
            var droStatusSelect = criteria.js(jsSelectors.droStatusSelect);
            var droPlanSelect = criteria.js(jsSelectors.droPlanSelect);
            var droEmployerSelect = criteria.js(jsSelectors.droEmployerSelect);
            var memberStatusSelect = criteria.js(jsSelectors.memberStatusSelect);
            var memberPlanSelect = criteria.js(jsSelectors.memberPlanSelect);
            var memberEmployerSelect = criteria.js(jsSelectors.memberEmployerSelect);

            // Get Select Helpers for selects where we're updating options and properties
            var participantTypeSelectHelper = selectHelper.getHelper(participantTypeSelect);
            var addressTypeSelectHelper = selectHelper.getHelper(addressTypeSelect);
            var benefitStatusSelectHelper = selectHelper.getHelper(benefitStatusSelect);
            var benefitTypeSelectHelper = selectHelper.getHelper(benefitTypeSelect);
            var insuranceCarrierSelectHelper = selectHelper.getHelper(insuranceCarrierSelect);
            var droStatusSelectHelper = selectHelper.getHelper(droStatusSelect);
            var droPlanSelectHelper = selectHelper.getHelper(droPlanSelect);
            var droEmployerSelectHelper = selectHelper.getHelper(droEmployerSelect);
            var memberStatusSelectHelper = selectHelper.getHelper(memberStatusSelect);
            var memberPlanSelectHelper = selectHelper.getHelper(memberPlanSelect);
            var memberEmployerSelectHelper = selectHelper.getHelper(memberEmployerSelect);

            // Register modeOptionSelect changed event
            modeSelect.change(modeChanged);

            // Register useDefaultAddressTypeCheckBox changed event 
            useDefaultAddressTypeCheckBox.change(useDefaultAddressTypeChanged);

            // Register participantTypeSelect changed event
            participantTypeSelect.change(participantTypeChanged);

            // Register droPlanSelect changed event
            droPlanSelect.change(droPlanChanged);

            // Register memberPlanSelect changed event
            memberPlanSelect.change(memberPlanChanged);

            // On mode change, handle display of group or individual containers
            function modeChanged() {

                var selectedMode = modeSelect.val();

                // display group or individual containers based on selected mode
                if (selectedMode == modes.group) {
                    visibility.show(groupModeContainer);
                    visibility.hide(individualModeContainer);
                }
                else {
                    visibility.hide(groupModeContainer);
                    visibility.show(individualModeContainer);
                }

                // reset participant type control and children, and clear errors            
                participantTypeSelectHelper.setValue("");
                participantTypeSelect.clearErrors();   
                participantTypeChanged();
            }

            // On participant type changed, handle display of child fields
            function participantTypeChanged() {

                var selectedParticipantType = participantTypeSelect.val();

                // hide all participant containers by default
                visibility.hide(participantRecipientContainer);
                visibility.hide(participantDroContainer);
                visibility.hide(participantMemberContainer);

                // enable/disable child controls based on which container is going to be visible
                droStatusSelectHelper.setDisabled(selectedParticipantType != participantTypes.dro);
                droPlanSelectHelper.setDisabled(selectedParticipantType != participantTypes.dro);
                droEmployerSelectHelper.setDisabled(selectedParticipantType != participantTypes.dro);
                memberStatusSelectHelper.setDisabled(selectedParticipantType != participantTypes.member);
                memberPlanSelectHelper.setDisabled(selectedParticipantType != participantTypes.member);
                memberEmployerSelectHelper.setDisabled(selectedParticipantType != participantTypes.member);

                if (selectedParticipantType == participantTypes.benefitRecipient) {

                    // show benefit recipient container
                    visibility.show(participantRecipientContainer);

                    // populate carriers based on selected type
                    insuranceCarrierSelectHelper.loadOptionsFrom(backendUrls.getInsuranceCarriers, {}, { withBlank: true });
                }
                else if (selectedParticipantType == participantTypes.dro) {

                    // show dro container
                    visibility.show(participantDroContainer);

                    // populate dro plans and employers
                    droPlanSelectHelper.loadOptionsFrom(backendUrls.getPlans, {}, { withBlank: true });
                    droEmployerSelectHelper.loadOptionsFrom(backendUrls.getEmployers, {}, { withBlank: true });
                }
                else if (selectedParticipantType == participantTypes.member) {

                    // show member container
                    visibility.show(participantMemberContainer);

                    // populate member plans and employers
                    memberPlanSelectHelper.loadOptionsFrom(backendUrls.getPlans, {}, { withBlank: true });
                    memberEmployerSelectHelper.loadOptionsFrom(backendUrls.getEmployers, {}, { withBlank: true });
                }

                // reset child control values
                benefitStatusSelectHelper.setValue(""); 
                benefitTypeSelectHelper.setValue("");
                insuranceCarrierSelectHelper.setValue("");
                droStatusSelectHelper.selectIndex(0);
                droPlanSelectHelper.setValue("");
                droEmployerSelectHelper.setValue("");
                memberStatusSelectHelper.selectIndex(0);
                memberPlanSelectHelper.setValue("");
                memberEmployerSelectHelper.setValue("");
            }

            // On use default address type checkbox changed, enable/disable address type select
            function useDefaultAddressTypeChanged() {

                if (useDefaultAddressTypeCheckBox.is(":checked")) {

                    //disable and clear address select
                    addressTypeSelectHelper.setDisabled(true);
                    addressTypeSelectHelper.setValue("");
                    addressTypeSelect.clearErrors();
                }
                else {
                    //enable address select
                    addressTypeSelectHelper.setDisabled(false);
                }
            }

            // On dro plan changed, repopulate employers based on selected plan
            function droPlanChanged() {

                var selectedPlanKey = droPlanSelect.val();

                if (selectedPlanKey == "") {
                    droEmployerSelectHelper.loadOptionsFrom(backendUrls.getEmployers, null, { withBlank: true });
                }
                else {
                    droEmployerSelectHelper.loadOptionsFrom(backendUrls.getEmployers, { planKey: selectedPlanKey }, { withBlank: true });
                }
            }

            // On member plan changed, repopulate employers based on selected plan
            function memberPlanChanged() {

                var selectedPlanKey = memberPlanSelect.val();

                if (selectedPlanKey == "") {
                    memberEmployerSelectHelper.loadOptionsFrom(backendUrls.getEmployers, null, { withBlank: true });
                }
                else {
                    memberEmployerSelectHelper.loadOptionsFrom(backendUrls.getEmployers, { planKey: selectedPlanKey }, { withBlank: true });
                }
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);